import createHeartComponent from "@finn-no/favorite-heart-component";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

type Props = {
  adId: number;
};
const Favorite = ({ adId }: Props) => {
  const { logInId, locale, isMobile, mountOrigin } = useAppConfig();
  const Heart = createHeartComponent({
    userId: logInId ?? "",
    baseUri: `${mountOrigin}/favorite-frontend-api`,
    renderServerSide: false,
  });

  return (
    <Heart
      buttonClass="absolute top-0 right-0"
      itemType="Ad"
      itemId={adId}
      isMobile={isMobile}
      variant="heart-on-image"
      locale={locale as "en" | "nb" | "fi" | "da" | "sv"}
    />
  );
};

export default Favorite;
